import { Subscription } from 'rxjs';
import { ProcessParticipationService } from './../../../../services/process.participation.service';
import { ProcessParticipationAnswer } from './../../../../models/process-models';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SurveyInfrastructure, QuestionType } from '../../../../models/questions';

@Component({
  selector: 'app-text-form',
  templateUrl: './text-form.component.html',
  styleUrls: ['./text-form.component.scss', '../user-question-form-selector.component.scss']
})
export class TextFormComponent implements OnInit, OnDestroy {

  @Input() question: SurveyInfrastructure;
  @Output() questionAnswered = new EventEmitter<SurveyInfrastructure>();
  textQuestionForm: FormGroup;
  subscription: Subscription = new Subscription();

  constructor(private fb: FormBuilder,  private processParticipationservice: ProcessParticipationService) { }

  ngOnInit() {
    const processParticipationAnswer = [...this.question.processParticipationAnswers].shift();

    this.textQuestionForm = this.fb.group({
      customValue: [(processParticipationAnswer) ? processParticipationAnswer.customValue :
        '', [Validators.required, Validators.minLength(1)]]
    });
    this.subscription.add(this.textQuestionForm.valueChanges
        .subscribe(data => this.questionAnswered.emit({...this.question, processParticipationAnswers: [this.createAnswer(data.customValue)]})));
  }

  ngOnDestroy() {
      this.subscription.unsubscribe();
  }

  saveAnswer() {
    const customValue = this.textQuestionForm.controls['customValue'].value;
        const answer = this.addOrUpdateAnswer(customValue);
        this.subscription.add(this.processParticipationservice.addOrUpdateAnswer(this.question.processParticipationId, answer)
        .subscribe(x => {
          this.question.processParticipationAnswers = x;
          this.questionAnswered.emit(this.question);
        }));
  }

  getIsNumberForm(): boolean {
    return this.question.answerType === QuestionType.Number;
  }

  private addOrUpdateAnswer(customValue: string): ProcessParticipationAnswer {
    let textAnswer = [...this.question.processParticipationAnswers].shift();
    if (textAnswer) {
      textAnswer.customValue = customValue;
    } else {
      textAnswer = this.createAnswer(customValue);
    }
    return textAnswer;
  }

  private createAnswer(customValue: string): ProcessParticipationAnswer {
    return {
      processParticipationId: this.question.processParticipationId,
      customValue: customValue,
      surveyInfrastructureId: this.question.id
    };
  }
}
